<app-modal-dialog title="Provide credentials" (dismiss)="cancel()">

    <main>
        <form #form="ngForm">
            <app-layout-row>
                <app-layout-column [width]="12">
                    <p>Please provide the credentials to be used by the partner.</p>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="6">

                    <app-textbox [ngModel]="username()" name="username" caption="Username" (valueChange)="username.set($event)"></app-textbox>
                    
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="6">

                    <app-password [ngModel]="password()" name="password" caption="Password" [validate]="false" [mode]="PasswordMode.Secret" [allowShowPassword]="true" (valueChange)="password.set($event)"></app-password>

                </app-layout-column>
            </app-layout-row>
        </form>
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary (buttonClick)="provide()">Ok</app-button>
        <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>